/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.browser.composable.component

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.Div
import systems.frictionless.impulse.browser.id.HtmlId
import systems.frictionless.impulse.browser.style.AppStyleSheet

/**
 * Holds whole content. Is responsible for backgrounds and padding of the content.
 */
@Composable
fun ContentContainer(
    navigationSection: SideNavigationSection? = null,
    mainContainerCssClass: String? = null,
    progressArea: @Composable (() -> Unit?)? = null,
    mainContentContainerId: HtmlId? = null,
    mainContent: @Composable () -> Unit
) {
    Div(attrs = {
        classes(AppStyleSheet.contentContainer, AppStyleSheet.whiteBoxEnabled)
        if (navigationSection == null) {
            classes(AppStyleSheet.noNavigation)
        }
        if (progressArea == null) {
            classes(AppStyleSheet.noProgress)
        }
    }) {
        navigationSection?.let {
            SideNavigation(it)
        }
        Div(attrs = {
            classes(AppStyleSheet.mainContainer)
            mainContentContainerId?.let { id(mainContentContainerId.idString) }
            mainContainerCssClass?.let {
                classes(it)
            }
        }) {
            mainContent()
        }
        progressArea?.let {
            Div(attrs = {
                classes(AppStyleSheet.progressContainer)
            }) {
                progressArea.invoke()
            }
        }
    }
}
